/**
 * EmptyState — centered illustration + heading + body + optional CTA.
 *
 * Replaces the various "No X yet" patterns scattered across pages.
 */

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className = '',
  compact = false,
}) {
  return (
    <div className={`text-center ${compact ? 'py-8' : 'py-12'} ${className}`}>
      {Icon && (
        <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-muted text-ink-muted mb-4">
          <Icon className="w-7 h-7" aria-hidden="true" />
        </span>
      )}
      {title && <h3 className="text-base font-semibold text-ink-primary mb-1">{title}</h3>}
      {description && <p className="text-sm text-ink-muted max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  )
}
